import { isNull } from 'lodash'
import resetOn from './resetOn'
import { isWantAction, removeOwner } from './helpers'
import {
  GET_ITEM_DETAIL_LOADING,
  GET_ITEM_DETAIL_SUCCESS,
  GET_ITEM_DETAIL_FAILURE,
  GET_ITEM_DETAIL_UNLOAD,
  I_WANT_LOADING,
  I_WANT_FAILURE,
  I_WANT_SUCCESS,
  I_WANT_NOT_LOADING,
  I_WANT_NOT_FAILURE,
  I_WANT_NOT_SUCCESS,
  SET_ITEM_NOT_OWNED_LOADING,
  SET_ITEM_NOT_OWNED_SUCCESS,
  SET_ITEM_NOT_OWNED_FAILURE,
  OWNED_ITEM_UPDATED,
  CAN_SWAP_ITEM_LOADING,
  CAN_SWAP_ITEM_FAILURE,
  CAN_SWAP_ITEM_SUCCESS,
  CAN_PROPOSE_SWAP_ITEM_LOADING,
  CAN_PROPOSE_SWAP_ITEM_FAILURE,
  CAN_PROPOSE_SWAP_ITEM_SUCCESS,
  REMOVE_INTEREST_LOADING,
  REMOVE_INTEREST_FAILURE,
  REMOVE_INTEREST_SUCCESS,
} from '../actions'

const defaultState = {
  loading: false,
  error: null,
  item: null,
  wantedLoading: false,
  ownedLoading: false,
  // Posso proporre uno scambio per l'oggetto?
  canProposeSwap: null,
  canProposeSwapLoading: false,
  // Posso scambiare il mio oggetto con qualocosa?
  canSwap: null,
  canSwapLoading: false,
  // Interest removing...
  removingInterest: false,
  interestRemoved: false,
}

export default resetOn(
  GET_ITEM_DETAIL_UNLOAD,
  (prevState = defaultState, action) => {
    const { type, payload, meta, error } = action

    // Ignore want actions not realted to this item
    if (
      isWantAction(action) &&
      (isNull(prevState.item) || prevState.item.id !== payload)
    ) {
      return prevState
    }

    // Normal handling of actions
    switch (type) {
      case GET_ITEM_DETAIL_SUCCESS:
        return {
          ...prevState,
          loading: false,
          item: payload,
        }

      case GET_ITEM_DETAIL_LOADING:
        return {
          ...prevState,
          loading: true,
          error: null,
        }
      case GET_ITEM_DETAIL_FAILURE:
        return {
          ...prevState,
          loading: false,
          error,
        }
      case I_WANT_LOADING:
      case I_WANT_NOT_LOADING:
        return {
          ...prevState,
          wantedLoading: true,
        }
      case I_WANT_FAILURE:
      case I_WANT_NOT_FAILURE:
        return {
          ...prevState,
          wantedLoading: false,
        }
      case I_WANT_SUCCESS:
        return {
          ...prevState,
          wantedLoading: false,
          item: meta && meta.item
            ? meta.item
            : {
                ...prevState.item,
                voluto: true,
              },
        }
      case I_WANT_NOT_SUCCESS:
        return {
          ...prevState,
          wantedLoading: false,
          item: {
            ...prevState.item,
            voluto: false,
          },
        }

      case OWNED_ITEM_UPDATED:
        return {
          ...prevState,
          item: payload,
        }
      // TODO: Maybe check action is for current object...
      case SET_ITEM_NOT_OWNED_LOADING:
        return {
          ...prevState,
          ownedLoading: true,
        }
      case SET_ITEM_NOT_OWNED_FAILURE:
        return {
          ...prevState,
          ownedLoading: false,
        }
      case SET_ITEM_NOT_OWNED_SUCCESS:
        return {
          ...prevState,
          ownedLoading: false,
          item: removeOwner(prevState.item, payload.userId),
        }

      case CAN_PROPOSE_SWAP_ITEM_LOADING:
        return {
          ...prevState,
          canProposeSwap: null,
          canProposeSwapLoading: true,
        }
      case CAN_PROPOSE_SWAP_ITEM_SUCCESS:
        return {
          ...prevState,
          canProposeSwap: payload,
          canProposeSwapLoading: false,
        }
      // TODO: Maybe handle error...
      case CAN_PROPOSE_SWAP_ITEM_FAILURE:
        return {
          ...prevState,
          canProposeSwap: null,
          canProposeSwapLoading: false,
        }

      case CAN_SWAP_ITEM_LOADING:
        return {
          ...prevState,
          canSwap: null,
          canSwapLoading: true,
        }
      case CAN_SWAP_ITEM_SUCCESS:
        return {
          ...prevState,
          canSwap: payload,
          canSwapLoading: false,
        }
      // TODO: Maybe handle error...
      case CAN_SWAP_ITEM_FAILURE:
        return {
          ...prevState,
          canSwap: null,
          canSwapLoading: false,
        }
      case REMOVE_INTEREST_LOADING:
      case REMOVE_INTEREST_SUCCESS:
      case REMOVE_INTEREST_FAILURE: {
        if (isNull(prevState.item) || prevState.item.id !== payload) {
          return prevState
        }

        switch (type) {
          case REMOVE_INTEREST_LOADING:
            return {
              ...prevState,
              removingInterest: true,
            }
          case REMOVE_INTEREST_SUCCESS:
            return {
              ...prevState,
              interestRemoved: true,
              removingInterest: false,
            }
          case REMOVE_INTEREST_FAILURE:
            return {
              ...prevState,
              removingInterest: false,
            }
          default:
            return prevState
        }
      }

      default:
        return prevState
    }
  }
)



// WEBPACK FOOTER //
// ./src/reducers/itemDetail.js